import type { CmlContent } from 'bundles/cml';

import NaptimeResource from './NaptimeResource';

export type ClipId = {
  courseId: string;
  itemId: string;
};

export type CurriculumItemId = 'courseId' | 's12nId' | 'domainId' | 'subdomainId';
export type ClipItem = {
  typeName: 'clipId';
  definition: ClipId;
};

export type CurriculumItem =
  | {
      typeName: CurriculumItemId;
      definition: {
        id: string;
      };
    }
  | ClipItem;

export type Track = {
  id: string;
  title: string;
  description: CmlContent;
  allCurriculumItemIds: string[];
  badgeTemplateId?: string;
  isLocked?: boolean;
  curriculumItems: CurriculumItem[];
  roleId?: string;
  creationSource?: 'CURATED_COLLECTION' | 'LEARNING_PATH';
  referenceCollectionConfiguration?: {
    referenceCollectionId: {
      typeName: 'presetCollectionId';
      definition: {
        id: string;
      };
    };
    enableSync: boolean;
  };
};
export class ProgramCurriculums extends NaptimeResource {
  static RESOURCE_NAME = 'programCurriculums.v1';

  declare id: string;

  declare typeName: 'tracksCurriculum' | 'wildcardCurriculum';

  declare definition: {
    coreTracks: Track[];
    electiveTracks: Track[];
    allS12nIds: string[];
    allCourseIds: string[];
  };

  declare accessType: string;
}

export default ProgramCurriculums;
